const LANGUAGE_KEY = 'admin_language';
const TIMEZONE_KEY = 'admin_timezone';

class AdminPreferencesStorage {
  save(language: string, timezone: string): void {
    sessionStorage.setItem(LANGUAGE_KEY, language);
    sessionStorage.setItem(TIMEZONE_KEY, timezone);
  }

  getLanguage(): string | null {
    return sessionStorage.getItem(LANGUAGE_KEY);
  }

  getTimezone(): string | null {
    return sessionStorage.getItem(TIMEZONE_KEY);
  }

  clear(): void {
    sessionStorage.removeItem(LANGUAGE_KEY);
    sessionStorage.removeItem(TIMEZONE_KEY);
  }
}

export const adminPreferencesStorage = new AdminPreferencesStorage();
